__turbopack_context__.v({
  "accordionSlideOverwrite": "navFeatured-module-scss-module__IwAAMG__accordionSlideOverwrite",
  "arrow": "navFeatured-module-scss-module__IwAAMG__arrow",
  "cardWrap": "navFeatured-module-scss-module__IwAAMG__cardWrap",
  "eyebrow": "navFeatured-module-scss-module__IwAAMG__eyebrow",
  "fadeIn": "navFeatured-module-scss-module__IwAAMG__fadeIn",
  "fadeOut": "navFeatured-module-scss-module__IwAAMG__fadeOut",
  "featured": "navFeatured-module-scss-module__IwAAMG__featured",
  "scaleIn": "navFeatured-module-scss-module__IwAAMG__scaleIn",
  "scaleOut": "navFeatured-module-scss-module__IwAAMG__scaleOut",
  "zoomIn": "navFeatured-module-scss-module__IwAAMG__zoomIn",
  "zoomOut": "navFeatured-module-scss-module__IwAAMG__zoomOut",
});
